import fetch from 'services'

export const saveTrackingEvent = (eventName, trackingInfo) =>
    fetch(`/support/event`, {
        method: 'POST',
        data: { eventName, ...trackingInfo },
    })

export const requestAppDownloadSms = (phonenumber, app) =>
    fetch('/notification/sms/', {
        method: 'POST',
        data: { phonenumber, app },
    })

export const getStatus = () => fetch('/status/')
